import { useEffect, useState } from "react";

const useKeyPress = (targetKey: number): boolean => {
  // State for keeping track of whether key is pressed
  const [keyPressed, setKeyPressed] = useState(false);
  // If pressed key is our target key then set to true
  function downHandler({ keyCode }: { keyCode: number }): void {
    if (keyCode === targetKey) {
      setKeyPressed(true);
    }
  }
  // If released keyCode is our target keyCode then set to false
  const upHandler = ({ keyCode }: { keyCode: number }): void => {
    if (keyCode === targetKey) {
      setKeyPressed(false);
    }
  };
  // Add event listeners
  useEffect(() => {
    window.addEventListener("keydown", downHandler);
    window.addEventListener("keyup", upHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener("keydown", downHandler);
      window.removeEventListener("keyup", upHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetKey]); // Empty array ensures that effect is only run on mount and unmount
  return keyPressed;
};

export default useKeyPress;
